import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-contract",
  "use": "icon-contract-usage",
  "viewBox": "0 -960 960 960",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -960 960 960\" id=\"icon-contract\"><path d=\"M225-80q-43.75 0-74.375-30.625T120-185v-135h120v-560h600v695q0 43.75-30.625 74.375T735-80H225Zm509.912-60Q754-140 767-152.938q13-12.937 13-32.062v-635H300v500h390v135q0 19.125 12.912 32.062 12.913 12.938 32 12.938ZM360-640v-60h360v60H360Zm0 120v-60h360v60H360ZM224-140h406v-120H180v75q0 19.125 13 32.062Q206-140 224-140Zm0 0h-44 450-406Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol